import { useNavigate } from "react-router-dom";

const services = [
  { name: "Salon", icon: "1447/1447987.png" },
  { name: "Plumber", icon: "2921/2921822.png" },
  { name: "Car Wash", icon: "741/741407.png" },
  { name: "Carpenter", icon: "3063/3063822.png" },
  { name: "Ironing", icon: "2861/2861482.png" },
  { name: "Marketing", icon: "9068/9068960.png" },
  { name: "Sales & Mrs", icon: "921/921056.png" },
  { name: "Gas Connection", icon: "10284/10284115.png" },
  { name: "Water Supplier", icon: "7207/7207313.png" },
  { name: "Car Washer", icon: "4320/4320371.png" }
];

function Services() {
  const navigate = useNavigate();

  return (
    <>
      <h2 className="section-title">Popular Services</h2>

      <div className="grid">
        {services.map((item, index) => (
          <div
            className="card"
            key={index}
            onClick={() => navigate(`/service/${item.name}`)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={`https://cdn-icons-png.flaticon.com/512/${item.icon}`}
              alt={item.name}
            />
            <p>{item.name}</p>
          </div>
        ))}
      </div>
    </>
  );
}

export default Services;
